import { memo } from 'react'
import './styles.css'

const Button = memo(function Button({
  children,
  variant = 'primary',
  size = 'm',
  onClick,
  disabled = false,
  type = 'button',
  className = '',
  ...props
}) {
  // Construir clases: variant puede ser 'primary', 'primary-text', 'accent', o 'secondary'
  const variantClass = variant === 'primary-text' ? 'button--primary button--primary-text' : `button--${variant}`
  const sizeClass = size === 's' ? 'button--s' : 'button--m'
  const classes = `button ${variantClass} ${sizeClass} ${disabled ? 'button--disabled' : ''} ${className}`.trim()

  return (
    <button
      className={classes}
      onClick={onClick}
      disabled={disabled}
      type={type}
      {...props}
    >
      {children}
    </button>
  )
})

export default Button
